import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PlanoSeguro {
  id: string;
  nome: string;
  descricao?: string;
  valor_por_painel: number;
  cobertura_detalhes?: any;
  vigencia_meses: number;
  inclui_limpeza?: boolean;
  ativo: boolean;
  created_at: string;
  updated_at: string;
}

export function usePlanosSeguro() {
  return useQuery({
    queryKey: ['planos-seguro'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('planos_seguro')
        .select('*')
        .eq('ativo', true)
        .order('nome');

      if (error) {
        console.error('Erro ao buscar planos de seguro:', error);
        throw error;
      }

      return data as PlanoSeguro[];
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}

export function usePlanoSeguro(id: string) {
  return useQuery({
    queryKey: ['plano-seguro', id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('planos_seguro')
        .select('*')
        .eq('id', id)
        .single();

      if (error) {
        console.error('Erro ao buscar plano de seguro:', error);
        throw error;
      }

      return data as PlanoSeguro;
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}

// Função para calcular valor do seguro
export function calcularValorSeguro(planoId: string, quantidadePaineis: number): number {
  // Esta função seria implementada com a lógica real de cálculo
  // Por enquanto, retorna um valor baseado no plano e quantidade
  const planosBase = {
    'plano-basico': 50.00,
    'plano-intermediario': 75.00,
    'plano-premium': 100.00
  };
  
  const valorPorPainel = planosBase[planoId as keyof typeof planosBase] || 50.00;
  return valorPorPainel * quantidadePaineis;
} 